<template>
  <validation-observer :ref="field + '-observer'">
    <b-form-group
      :label-for="field"
    >
      <label> <span
        v-if="isRequired()"
        class="text-danger"
      >*</span> {{ $t(label) }} <span class="text-primary">( {{
        $t('Maximum file size is {size} MB', {size})
      }} ) {{ isRequired() ? '' : `( ${$t(notRequired)} )` }} </span></label>
      <b-progress
        v-if="loading"
        max="100"
        show-progress
        height="2.58rem"
      >
        <b-progress-bar
          :value="uploadPercentage"
          :label="uploadPercentage + '%'"
          variant="success"
        />
      </b-progress>
      <div v-else>
        <div
          v-if="applyDocument[field]"
          class="input-group"
        >
          <div class="input-group-prepend">
            <span class="input-group-text border-success">
              <b-link
                :href="applyDocument[field]"
                download="file"
                target="_blank"
              >
                <feather-icon
                  icon="DownloadIcon"
                  class="cursor-pointer"
                  size="16"
                />
              </b-link>

            </span>
            <span class="input-group-text border-success">
              <router-link :to="{ name:'pdf-viewer',params: {url: applyDocument[field] } }">
                <feather-icon
                  icon="EyeIcon"
                  class="cursor-pointer"
                  size="16"
                />
              </router-link>
            </span>
          </div>
          <div
            class="form-control border-success overflow-auto"
          >
            {{ $t(label) }}
          </div>
          <div
            v-if="!frozen"
            class="input-group-append"
          >
            <span class="input-group-text">
              <feather-icon
                icon="XIcon"
                class="cursor-pointer danger"
                size="16"
                @click="cancel"
              />
            </span>
          </div>
        </div>
        <div v-else>
          <validation-provider
            v-if="!frozen"
            #default="{ errors }"
            :name="$t(label)"
            :rules="rules"
          >
            <b-form-file
              v-model="file"
              :placeholder="$t('Choose a file or drop it here...')"
              :accept="accept"
              :drop-placeholder="$t('Drop file here...')"
              :state="errors.length > 0 ? false:null"
              @change="handleFile"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
          <div
            v-else
            class="form-control"
          >
            {{ $t(label) }}
          </div>
        </div>
      </div>

    </b-form-group>
  </validation-observer>
</template>

<script>
import { localize, ValidationObserver, ValidationProvider } from 'vee-validate'
import {
  BFormFile, BFormGroup, BLink, BProgress, BProgressBar,
} from 'bootstrap-vue'
import { fileSize, required } from '@/libs/validations/validations'

export default {
  components: {
    BFormFile,
    BFormGroup,
    BLink,
    ValidationProvider,
    ValidationObserver,
    BProgress,
    BProgressBar,
  },
  props: {
    field: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    rules: {
      type: String,
      default: 'required|file-size:5',
    },
    accept: {
      type: String,
      default: 'application/pdf',
    },
    applyDocument: {
      type: Object,
      required: true,
    },
    frozen: {
      type: Boolean,
      default: false,
    },
    notRequired: {
      type: String,
      default: 'Not Required',
    },
  },
  data() {
    return {
      required,
      fileSize,
      file: null,
      loading: false,
      uploadPercentage: 0,
      size: 5,
    }
  },
  created() {
    localize(this.$i18n.locale)
  },
  mounted() {
    const match = this.rules.match(/file-size:(\d+)/)
    if (match && match[1]) {
      this.size = Number(match[1])
    }
  },
  methods: {
    handleFile(e) {
      setTimeout(() => {
        this.$refs[`${this.field}-observer`].validate().then(success => {
          if (success) {
            this.loading = true
            const params = new FormData()
            params.append(this.field, e.target.files[0])
            // eslint-disable-next-line no-unused-vars
            this.$store.dispatch('applyDocument/uploadFile', {
              id: this.applyDocument.id,
              body: params,
              onUploadProgress: progressEvent => {
                this.uploadPercentage = Number(Math.round((progressEvent.loaded / progressEvent.total) * 100))
              },
            }).then(res => {
              this.$bvToast.toast(this.$t('Successfully completed'), {
                variant: 'success',
                solid: true,
                title: this.$t('Success'),
              })
              this.applyDocument[this.field] = res.data
              this.$emit('callback', res)
            }).catch(err => {
              this.$errorSwal(this, err)
            }).finally(() => {
              this.loading = false
              this.uploadPercentage = 0
            })
          }
        })
      })
    },
    cancel() {
      this.file = null
      this.applyDocument[this.field] = null
    },
    isRequired() {
      return this.rules.split('|').includes('required')
    },
  },
}
</script>

<style scoped>

</style>
